import { FormControlLabel, Alert } from "@mui/material";
import { styled } from "@mui/material/styles";
const Row = styled("div")`
  display: flex;
  gap: 8px;
`;
const DurationWrapper = styled("div")`
  max-width: 200px;
`;
const WIDE_SIZE = 632;
const DEFAULT_SIZE = 432;
const FormWrapper = styled("div")`
  width: ${({ isWide }) => `${isWide ? WIDE_SIZE : DEFAULT_SIZE}px`};
  min-width: ${({ isWide }) => `${isWide ? WIDE_SIZE : DEFAULT_SIZE}px`};
  flex-grow: 0;
  overflow: auto;
`;
const LoaderWrapper = styled("div")`
  height: 56px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const BlockingFormField = styled(FormControlLabel)(({ theme }) => ({
  marginLeft: "3px",
  gap: "16px",
  color: theme.palette.grey[800],
  fontFamily: "Lato",
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "22px",
  letterSpacing: "0.5px"
}));
const Warning = styled(Alert)`
  width: 100%;
  margin-bottom: 8px;
`;
export {
  BlockingFormField,
  DurationWrapper,
  FormWrapper,
  LoaderWrapper,
  Row,
  Warning
};
